<app-task-details (close)="closeDrawer()"></app-task-details>
